/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentSearchResponse } from '../../models/content-search-response';

export interface SearchContent$Params {

/**
 * hodnota
 */
  value: string;
}

export function searchContent(http: HttpClient, rootUrl: string, params: SearchContent$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentSearchResponse>> {
  const rb = new RequestBuilder(rootUrl, searchContent.PATH, 'get');
  if (params) {
    rb.query('value', params.value, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContentSearchResponse>;
    })
  );
}

searchContent.PATH = '/client/content/search';
